import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "max-w-container px-container min-h-screen"
}
const _hoisted_2 = {
  key: 1,
  ref: "root",
  class: "max-w-container"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "\n        border-b border-amff-light-gray border-opacity-25\n        lg:float-right\n        lg:border-0\n        py-3\n        relative\n        z-10\n      " }, null, -1)
const _hoisted_4 = { class: "lg:text-sm" }
const _hoisted_5 = { class: "lg:text-lg" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 0,
  class: "mt-10 mb-20 lg:mt-28 lg:mb-44 text-center"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "\n            mb-6\n            lg:mb-10\n            h-14\n            lg:h-20\n            w-px\n            mx-auto\n            border-l border-dashed border-amff-pink\n          " }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BarricadeTape = _resolveComponent("BarricadeTape")
  const _component_LoadingIndicator = _resolveComponent("LoadingIndicator")
  const _component_Button = _resolveComponent("Button")
  const _component_HorizontalScroller = _resolveComponent("HorizontalScroller")
  const _component_EventItem = _resolveComponent("EventItem")
  const _component_ArrowIcon = _resolveComponent("ArrowIcon")
  const _component_EmptyEventsBlock = _resolveComponent("EmptyEventsBlock")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_BarricadeTape),
    (_ctx.isFetchingEvents)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode(_component_LoadingIndicator, { class: "mx-auto py-8" })
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_HorizontalScroller, {
            class: "border-b border-amff-light-gray py-4",
            scrollIntoView: _ctx.$refs[`eventTypeButton-${_ctx.filters.eventType}`]?.$el
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList([
          { eventType: undefined, label: _ctx.$t('events.event_types.all') },
          { eventType: 'projection', label: _ctx.$t('events.event_types.movies') },
          { eventType: 'concert', label: _ctx.$t('events.event_types.music') },
          { eventType: 'conference', label: _ctx.$t('events.event_types.talks') },
        ], ({ eventType, label }) => {
                return (_openBlock(), _createBlock(_component_Button, {
                  class: "lg:-ml-8",
                  key: label,
                  ref: `eventTypeButton-${eventType}`,
                  color: 
          _ctx.filters.eventType === eventType
            ? 'amff-pink-text'
            : eventType === undefined ||
              _ctx.availableEventTypesByDay.includes(eventType)
            ? 'amff-black-text'
            : 'amff-gray-text'
        ,
                  "aria-pressed": _ctx.filters.eventType === eventType,
                  "aria-current": undefined,
                  as: _ctx.AnchorLink,
                  to: {
          query: {
            ..._ctx.filters,
            eventType,
          },
        }
                }, {
                  default: _withCtx(() => [
                    _createVNode("div", _hoisted_4, _toDisplayString(label), 1)
                  ]),
                  _: 2
                }, 1032, ["color", "aria-pressed", "as", "to"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["scrollIntoView"]),
          _createVNode(_component_HorizontalScroller, {
            class: "border-b border-amff-light-gray py-3",
            scrollIntoView: _ctx.$refs[`dayButton-${_ctx.filters.day}`]?.$el
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.availableDays, (availableDay) => {
                return (_openBlock(), _createBlock(_component_Button, {
                  class: "lg:-ml-8",
                  key: availableDay,
                  ref: `dayButton-${availableDay}`,
                  color: 
          _ctx.filters.day === availableDay
            ? 'amff-teal-text'
            : _ctx.availableDaysByEventType.includes(availableDay)
            ? 'amff-black-text'
            : 'amff-gray-text'
        ,
                  "aria-pressed": _ctx.filters.day === availableDay,
                  "aria-current": undefined,
                  as: _ctx.AnchorLink,
                  to: {
          query: {
            ..._ctx.filters,
            day: availableDay,
          },
        }
                }, {
                  default: _withCtx(() => [
                    _createVNode("div", _hoisted_5, _toDisplayString(_ctx.formatDay(availableDay)), 1)
                  ]),
                  _: 2
                }, 1032, ["color", "aria-pressed", "as", "to"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["scrollIntoView"]),
          (_ctx.eventsFiltered.length)
            ? (_openBlock(), _createBlock("div", _hoisted_6, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.eventsFiltered, (event) => {
                  return (_openBlock(), _createBlock(_component_EventItem, {
                    key: event.id,
                    event: event
                  }, null, 8, ["event"]))
                }), 128)),
                (_ctx.nextAvailableDay)
                  ? (_openBlock(), _createBlock("div", _hoisted_7, [
                      _hoisted_8,
                      _createVNode(_component_Button, {
                        color: "amff-pink",
                        "aria-current": undefined,
                        as: _ctx.AnchorLink,
                        to: {
            query: {
              ..._ctx.filters,
              day: _ctx.nextAvailableDay,
            },
          },
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.scrollToTop()))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("events.go_to_next_day")) + " ", 1),
                          _createVNode(_component_ArrowIcon, {
                            fill: "currentColor",
                            class: "w-4 h-4"
                          })
                        ]),
                        _: 1
                      }, 8, ["as", "to"])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createBlock(_component_EmptyEventsBlock, { key: 1 }))
        ], 512))
  ], 64))
}